<template>

    <div>
        <h3 class="question__title">
            <span v-html="title" :id="'q_' + uuid"></span>
            <span v-if="hashelp" class="question__additionnal-info">
                <span class="question__help-btn" :data-question-id="uuid" @click.prevent.stop="displayHelp" @keyup.stop="keyDownHelp" :tabindex="questionIndex">
                    <svg width="20px" height="20px">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M8.81973653,19.5106641 L0.48974499,11.1806726 C-0.163005906,10.5279217 -0.163005906,9.47091027 0.48974499,8.81908658 L8.81973653,0.489095042 C9.47156022,-0.16272865 10.5285716,-0.16272865 11.1803953,0.489095042 L19.511314,8.81908658 C20.1631377,9.47091027 20.1631377,10.5279217 19.511314,11.1806726 L11.1803953,19.5106641 C10.5285716,20.1624878 9.47156022,20.1624878 8.81973653,19.5106641 Z" class="question__help__bg-fill" fill="#999"></path>
                            <path d="M9,16 L10.92,16 L10.92,8 L9,8 L9,16 Z M9,5.79727273 L10.92,5.79727273 L10.92,4 L9,4 L9,5.79727273 Z" fill="#FFFFFF"></path>
                        </g>
                    </svg>
                </span>
            </span>
            <div class="question__help" v-if="showHelp" v-on-clickaway="hideHelp">
                <div class="question__help__close" @click.stop="hideHelp"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></div>
                <p v-html="title" class="question__help--title"></p>
                <div v-html="helpContent" ref="helpContainer"></div>
            </div>
        </h3>
        <h5 class="question__sub-title" v-if="subTitle.length" v-html="subTitle"></h5>
    </div>

</template>

<script>
import { transmitter } from '../vuex/Transmitter';
import { mapState } from 'vuex';
import VueClickaway from 'vue-clickaway';
import { isNil } from 'lodash';
import { glossaryParser } from '../common/glossary-parser';

export default {
    name: 'question-title',

    mixins: [ VueClickaway.mixin ],

    props: {
        questionIndex: Number,
        uuid: Number,
        title: String,
        subTitle: String,
        hashelp: Boolean,
    },

    data()
    {
        return {
            helpContent: null,
            cachedHelpContent: null,
            helpCounterWas: 0,
        }
    },

    computed: {
        showHelp()
        {
            return (this.helpContent !== null && this.helpCounterWas === this.helpCounter);
        },
        ...mapState({
            helpCounter(state)
            {
                return state.helpCounter
            },
        }),
    },

    methods: {

        keyDownHelp($event)
        {
            if ($event.code === 'Enter' || $event.code === 'NumpadEnter')
            {
                $event.preventDefault();
                this.toggleHelp($event);
            }
            else if ($event.code === 'Escape')
            {
                this.hideHelp();
            }
        },

        toggleHelp($event)
        {
            if (this.helpContent === null)
            {
                this.displayHelp($event);
            }
            else
            {
                this.hideHelp();
            }
        },

        displayHelp($event)
        {
            this.helpContent = '…';
            this.$store.dispatch('NEXT_HELP_COUNTER');

            this.helpCounterWas = this.helpCounter;
            if (this.cachedHelpContent)
            {
                this.helpContent = this.cachedHelpContent;
                setTimeout(() =>
                {
                    if (!isNil(this.$refs.helpContainer))
                    {
                        glossaryParser.parse(this.$refs.helpContainer.parentElement);
                    }
                }, 10);
                return;
            }

            transmitter.getAdditionnalInfo(this.uuid).then((response) =>
            {
                this.helpContent = this.cachedHelpContent = response.data;
                setTimeout(() =>
                {
                    if (!isNil(this.$refs.helpContainer))
                    {
                        glossaryParser.parse(this.$refs.helpContainer.parentElement);
                    }
                }, 10);
            });
        },

        hideHelp()
        {
            this.helpContent = null;
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-title.vue